import axios from "axios";
import * as types from "../mutation-types";

// state
export const state = {
    assuntos: null
};

// getters
export const getters = {
    assuntos: state => state.assuntos
};

// mutations
export const mutations = {
    [types.FETCH_ASSUNTOS_SUCCESS](state, {assuntos}) {
        state.assuntos = assuntos
    },
    [types.FETCH_ASSUNTOS_FAILURE] (state) {
        state.assuntos = null
    }
};

// actions
export const actions = {
    async fetchAllAssuntos({commit}) {
        try {
            const {data: {data}} = await axios.get("/api/assuntos");
            commit(types.FETCH_ASSUNTOS_SUCCESS, {assuntos: data});
        } catch (e) {
            commit(types.FETCH_ASSUNTOS_FAILURE);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/assuntos.js